import React from 'react'
import './modal.css'
import { CircularProgress } from 'material-ui'

const Loading = props => (
  <CircularProgress
    style={{
      margin: 5,
      color: 'grey'
    }}
    size={20}
  />
)

export default Loading



// WEBPACK FOOTER //
// ./src/components/modals/Loading.js